import { Table } from 'antd';
import React from 'react';

import type { SalaryReportTableProps } from '@app/pages/Analytics/SalaryReport/types';
import { getSalaryTableConfig } from '@app/pages/Analytics/SalaryReport/utils';

const HEADER_HEIGHT = 400;

export const SalaryReportTable: React.FC<SalaryReportTableProps> = ({
  isLoading,
  onConfirm,
  tableData,
  handleEditableCellClick,
  handleRevokeConfirm,
  hasUserRightToConfirmSalary,
  hasUserRightToEditBefore,
  hasUserRightToEditAfterConfirm,
}) => {
  const { columns, dataSource } = getSalaryTableConfig({
    onConfirm,
    tableData,
    handleEditableCellClick,
    handleRevokeConfirm,
    hasUserRightToConfirmSalary,
    hasUserRightToEditBefore,
    hasUserRightToEditAfterConfirm,
  });

  return (
    <Table
      className="employee-salary-table table-border-dark"
      rowClassName={(record) => (record.IsDeleted ? 'row-deleted' : '')}
      bordered
      columns={columns}
      dataSource={dataSource}
      rowKey="key"
      pagination={false}
      loading={isLoading}
      scroll={{ x: 'max-content', y: `calc(100vh - ${HEADER_HEIGHT}px)` }}
    />
  );
};
